import { gql } from '@apollo/client';

export default class NotificationSubscription {
    static NOTIFICATION_UPDATED = gql`
        subscription notificationUpdated($type: String!) {
            notificationUpdated(type: $type) {
                type
                notificationSoundEnabled
                notification {
                    data
                    type
                    createdOn
                    notificationId
                    processRecordId
                    userNotification {
                        read
                    }
                }
            }
        }
    `;

    static RECEIVED_NOTIFICATION = gql`
        subscription receivedNotification($type: String!) {
            receivedNotification(type: $type) {
                data
                type
                createdOn
                notificationId
                processRecordId
                notificationSoundEnabled
            }
        }
    `;

    static OPPORTUNITY_NOTIFICATION_UPDATED = gql`
        subscription opportunityNotificationUpdated {
            opportunityNotificationUpdated {
                opportunityId
                emailUnread
                smsUnread
            }
        }
    `;

    static COMPANY_COMMUNICATION_NOTIFICATIONS_MODIFIED = gql`
        subscription {
            companyCommunicationCounterChanged {
                communications
                notificationSoundEnabled
            }
        }
    `;

    static TASK_DUE_NOTIFICATIONS_MODIFIED = gql`
        subscription {
            userTaskDueCounterChanged {
                userTaskDue
                notificationSoundEnabled
            }
        }
    `;
}
